import React from 'react';
import SemanticsContext from '../semantics_context/semantics_context';
function SemanticsProvider(_ref) {
  var {
    customSemantics,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(SemanticsContext.Provider, {
    value: {
      customSemantics
    }
  }, children);
}
export default SemanticsProvider;